export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center pt-20">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/caf3f7814e0f5b986976ce96bf702b5f.jpg"
          alt="Garderie Les Petits Champions"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 md:p-12 shadow-2xl">
            <div className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
              ⭐ 3 Places Disponibles
            </div>
            
            <p className="text-xl md:text-2xl text-orange-600 font-semibold mb-6">
              Là où chaque enfant devient un grand champion de la vie !
            </p>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Nous offrons un milieu chaleureux, sécuritaire et stimulant où chaque enfant peut grandir, s'épanouir et apprendre à son propre rythme. Notre mission est d'accompagner les tout-petits dans leur développement global — intellectuel, social, émotionnel et moteur.
            </p>

            <div className="flex items-center space-x-4 mb-8 text-gray-700">
              <div className="flex items-center space-x-2">
                <i className="ri-time-line text-orange-500 text-xl"></i>
                <span className="font-semibold">Depuis 2001</span>
              </div>
              <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
              <div className="flex items-center space-x-2">
                <i className="ri-award-line text-orange-500 text-xl"></i>
                <span className="font-semibold">24+ ans d'expérience</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => scrollToSection('programme')}
                className="bg-orange-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Découvrir notre programme
              </button>
              <a 
                href="tel:5149136280"
                className="border-2 border-orange-500 text-orange-500 px-8 py-4 rounded-full text-lg font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-phone-line mr-2"></i>
                (514) 913-6280
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
